module.exports = __webpack_public_path__ + "static/img/neirong.ba5bbe91.png";